import actiontypes from '../actiontypes'
import _ from 'common-tools/LodashHelper'

let actions = {}

actions[actiontypes.LayoutContent.ClearSearch] = (state, action) => {
  let newState = _.merge({}, state)

  newState.search.delete(action.payload.path)
  return newState
}

actions[actiontypes.LayoutContent.SetSearch] = (state, action) => {
  let newState = _.merge({}, state)

  if (newState.search.has(action.payload.path)) {
    newState.search.delete(action.payload.path)
  }

  newState.search.set(action.payload.path, action.payload.value)
  return newState
}

actions[actiontypes.LayoutContent.AddBreadCrumbKey] = (state, action) => {
  let newState = _.merge({}, state)

  let match = _.find(newState.BreadCrumbKeys, { key: action.payload.key })

  if (match) {
    match.value = action.payload.value
  } else {
    newState.BreadCrumbKeys.push(action.payload)
  }

  return newState
}

actions[actiontypes.LayoutContent.ClearBreadCrumbKeys] = (state, action) => {
  let newState = _.merge({}, state)

  newState.BreadCrumbKeys = []
  return newState
}

actions[actiontypes.LayoutContent.ClearMenus] = (state, action) => {
  let newState = _.merge({}, state)

  newState.menus.delete(action.payload.path)
  return newState
}

actions[actiontypes.LayoutContent.SetMenus] = (state, action) => {
  let newState = _.merge({}, state)

  if (newState.menus.has(action.payload.path)) {
    newState.menus.delete(action.payload.path)
  }
  newState.menus.set(action.payload.path, action.payload.value)
  return newState
}

actions[actiontypes.LayoutContent.SetMenusLoading] = (state, action) => {
  let newState = _.merge({}, state)

  let pathMenus = newState.menus.get(action.payload.path)

  if (_.isArray(pathMenus) === false) {
    // exit
    return newState
  }

  const loadingInfo = action.payload.loadingInfo || {}

  const loadingAction = loadingInfo.Action || 'clear'
  const loadingId = _.isArray(loadingInfo.Ids) === true ? loadingInfo.Ids : [loadingInfo.Ids || '']

  _.forEach(pathMenus, (m) => {
    let isLoading = false
    let isDisabled = false

    if (loadingAction !== 'clear') {
      if (_.indexOf(loadingId, m.id) !== -1) {
        isLoading = true
      }
      isDisabled = true
    }
    m.loading = isLoading
    m.disabled = isDisabled
  })

  return newState
}

actions[actiontypes.LayoutContent.AddMenu] = (state, action) => {
  let newState = _.merge({}, state)

  let pathMenus = newState.menus.get(action.payload.path)

  if (_.isArray(pathMenus) === false) {
    pathMenus = []
    newState.menus.set(action.payload.path, pathMenus)
  }

  // if not exist add else update some props
  const match = _.find(pathMenus, { id: action.payload.value.id })
  if (!match) {
    pathMenus.push(action.payload.value)
  } else {
    match.onClick = action.payload.value.onClick
  }

  return newState
}

actions[actiontypes.LayoutContent.RemoveMenu] = (state, action) => {
  let newState = _.merge({}, state)

  let pathMenus = newState.menus.get(action.payload.path)

  if (_.isArray(pathMenus) === false) {
    pathMenus = []
    newState.menus.set(action.payload.path, pathMenus)
  }

  _.remove(pathMenus, { id: action.payload.id })

  return newState
}

export default (state = {
  search: new Map(),
  menus: new Map(),
  BreadCrumbKeys: []
}, action) => {
  if (_.startsWith(action.type, actiontypes.LayoutContent.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
